import { render, staticRenderFns } from "./AddClientForm.vue?vue&type=template&id=1cbc8116&scoped=true&"
import script from "./AddClientForm.vue?vue&type=script&lang=js&"
export * from "./AddClientForm.vue?vue&type=script&lang=js&"
import style0 from "./AddClientForm.vue?vue&type=style&index=0&id=1cbc8116&prod&lang=scss&scoped=true&"
import style1 from "./AddClientForm.vue?vue&type=style&index=1&id=1cbc8116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc8116",
  null
  
)

export default component.exports